// import { hashEncodeUserDataField } from '~/utils/hashEncodeUserDataField';
type FieldType = 'phone' | 'email' | 'name' | 'address' | 'city' | 'state' | 'zip';
export const hashEncodeUserDataField = async (
  value: string | null | undefined,
  type: FieldType
): Promise<string | null> => {
  if (!value) return null;

  let normalized = value.toString().toLowerCase().trim();

  switch (type) {
    case 'phone':
      normalized = normalized.replace(/\D/g, ''); // Keep digits only
      break;
    case 'email':
      // Already lowercased and trimmed
      break;
    case 'name':
    case 'address':
    case 'city':
    case 'state':
      normalized = normalized.replace(/[^a-z]/g, ''); // Keep only letters
      break;
    case 'zip':
      normalized = normalized.replace(/\s/g, ''); // Remove spaces
      break;
    default:
      normalized = normalized.replace(/\s/g, ''); // Fallback: remove spaces
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(normalized);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};
